import React from 'react';
import * as FiIcons from 'react-icons/fi';
const {FiInfo,FiArrowRight,FiPhone}=FiIcons;

const BOOKING_URL="https://app.urable.com/virtual-shop/cFNwotdAvEx76Evup5X1";

export default function VehicleNote({variant='default'}) {
  if (variant==='compact') {
    return ( 
      <div className="flex items-start gap-3 bg-slate-900/60 border border-slate-700/60 rounded-sm px-5 py-4"> 
        <FiInfo className="text-blue-400 text-base flex-shrink-0 mt-0.5" /> 
        <p className="text-slate-400 text-sm leading-relaxed"> 
          <span className="text-slate-200 font-semibold">Vehicle outside the standard sizes?</span>{' '} 
          Head over to our booking portal and we'll help guide you to the right option. 
        </p> 
      </div> 
    );
  } 
  
  return ( 
    <div className="bg-slate-900 border border-slate-700/80 rounded-sm p-6 flex flex-col sm:flex-row items-start sm:items-center gap-5"> 
      <div className="w-10 h-10 bg-blue-600/15 border border-blue-500/25 rounded-sm flex items-center justify-center flex-shrink-0"> 
        <FiInfo className="text-blue-400 text-lg" /> 
      </div> 
      <div className="flex-grow"> 
        <p className="text-white font-bold text-sm uppercase tracking-wide mb-1"> 
          Have a larger or specialty vehicle? 
        </p> 
        <p className="text-slate-400 text-sm leading-relaxed"> 
          If your vehicle doesn't fit the standard size categories,we can still help — just select it in the booking portal. 
        </p> 
      </div> 
      <div className="flex flex-col sm:flex-row gap-2 flex-shrink-0"> 
        <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 bg-blue-600 text-white font-bold rounded-sm hover:bg-blue-500 transition-all uppercase tracking-wide text-xs whitespace-nowrap" > 
          Book Now <FiArrowRight className="text-xs" /> 
        </a> 
        <a href="tel:9048312184" className="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 border border-slate-700 text-slate-300 font-bold rounded-sm hover:border-blue-500 hover:text-blue-400 transition-all uppercase tracking-wide text-xs whitespace-nowrap" > 
          <FiPhone className="text-xs" /> (904) 831-2184 
        </a> 
      </div> 
    </div> 
  );
}